module.exports = __webpack_public_path__ + "static/img/ico_message.61f9c10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ico_message.svg
// module id = TVn4
// module chunks = 10